import React from "react";
import UserGeneratedContent from "~/components/terms/UserGeneratedContent";
import WebsiteTermsOfService from "~/components/terms/WebsiteTermsOfService";
import PrivacyPolicy from "~/components/terms/PrivacyPolicy";
import TeacherTermsOfService from "~/components/terms/TeacherTermsOfService";
import BookingTermsOfService from "~/components/terms/BookingTermsOfService";
import ObbyGiftCards from "~/components/terms/ObbyGiftCards";
import { useEffect } from "react";
import { styles } from "./TermsPage.style";

export function TermsPageView(props) {
  useEffect(() => {
    let dataTrack = {
      name: "Terms",
      path: window.location.pathname || "",
      referrer: document.referrer || "",
      title: document.title || "",
      url: window.location.href
    };
    if (window.rudderanalytics)
      window.rudderanalytics.page(dataTrack.name, dataTrack);
  }, []);
  const sections = {
    terms: {
      title: "Website Terms of Service",
      component: WebsiteTermsOfService
    },
    "teacher-terms": {
      title: "Teacher Terms of Service",
      component: TeacherTermsOfService
    },
    "booking-terms": {
      title: "Booking Terms of Service",
      component: BookingTermsOfService
    },
    "obby-gift-cards": {
      title: "Obby Gift Cards",
      component: ObbyGiftCards
    },
    "privacy-policy": {
      title: "Privacy Policy",
      component: PrivacyPolicy
    },
    ugc: {
      title: "User Generated Content",
      component: UserGeneratedContent
    }
  };
  const selectedSection = sections[props.section] || sections["terms"];
  const Component = selectedSection.component;

  return (
    <section className={styles.terms()}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-3 mb-4">
            <ul className={styles.sideNav()}>
              {Object.keys(sections).map(section => (
                <li
                  key={section}
                  className={`${styles.sideNavItem()} ${
                    section === props.section
                      ? `${styles.sideNavItemSelected()}`
                      : ""
                  }`}
                >
                  <a
                    className={styles.sideNavItemLink()}
                    href={`/terms/${section}`}
                  >
                    {sections[section].title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-12 col-md-9">
            <Component />
          </div>
        </div>
      </div>
    </section>
  );
}
